<template>
  <div>
    <page-header>
      <template #title>
        <h1 class="page-title">
          QC Queue
        </h1>
      </template>
    </page-header>

    <div class="row">
      <div class="col-lg-12">
        <div class="card mb-3">
          <div class="loading-overlay" v-if="loading"></div>
          <div class="card-header">
            <div class="row w-100">
              <div class="col">
                <selectlist
                  name="abi_group_id"
                  label="ABI Group"
                  :value="filters.abi_group_id"
                  @input="setAbiGroup"
                  :options="vehicleGroups"
                  :stacked="true"
                  key-name="id"
                  label-name="name"
                ></selectlist>
              </div>
              <div class="col">
                <selectlist
                  name="status"
                  label="Status"
                  :value="filters.status"
                  @input="setStatus"
                  :options="statuses"
                  :stacked="true"
                  key-name="key"
                  label-name="value"
                ></selectlist>
              </div>
            </div>
          </div>

          <div class="table-responsive">
            <table class="table">
              <thead>
                <tr>
                  <th>Vehicle</th>
                  <th>ABI Group</th>
                  <th>PDI Number</th>
                  <th>Status</th>
                  <th>QC Number</th>
                  <th>&nbsp;</th>
                </tr>
              </thead>
              <tbody v-if="!!qcs && qcs.length">
                <tr v-bind:key="index" v-for="(qc, index) in qcs">
                  <td>
                    {{ qc.vehicle?.registration }}
                  </td>
                  <td>
                    {{ qc.abiGroup?.name }}
                  </td>
                  <td>
                    <router-link
                      v-if="qc.pdi"
                      :to="`/pdi-queue/${qc.pdi.identifier}`"
                      target="_blank"
                    >
                      {{ qc.pdi.pdi_number }}
                    </router-link>
                  </td>
                  <td>
                    <span class="badge" :class="statusClass(qc.status)">
                      {{ statusLabel(qc.status) }}
                    </span>
                  </td>
                  <td>
                    {{ qc.qc_number }}
                  </td>
                  <td class="text-right">
                    <router-link
                      class="btn btn-primary"
                      :to="`/qc-queue/${qc.identifier}`"
                    >
                      View
                    </router-link>
                  </td>
                </tr>
              </tbody>
              <tbody v-if="!qcs.length">
                <tr>
                  <td colspan="6" class="text-center">
                    No results found
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="card-footer text-right" v-show="showPagination">
            <pagination
              :data="paginator_data"
              v-on:updateResults="getData"
            ></pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import PageHeader from './../Shared/PageHeader.vue';

export default {
  components: {
    PageHeader
  },

  data() {
    return {
      loading: false,
      qcs: [],
      paginator_data: {},
      filters: {
        abi_group_id: null,
        status: null
      },
      statuses: [
        {
          key: null,
          value: 'All'
        },
        {
          key: 'completed',
          value: 'Completed'
        },
        {
          key: 'not_started',
          value: 'Not Started'
        },
        {
          key: 'qc_rectification',
          value: 'QC Rectification'
        }
      ]
    };
  },

  computed: {
    showPagination() {
      return (
        this.paginator_data.next_page_url || this.paginator_data.prev_page_url
      );
    },

    vehicleGroups() {
      return this.$store.getters['VehicleGroups/all'];
    }
  },

  mounted() {
    this.$store.commit('VehicleGroups/retrieve');

    this.getQcs();
  },

  methods: {
    getQcs() {
      this.getData(`/qc?per_page=${this.perPage}`);
    },

    getData(url) {
      Object.keys(this.filters).forEach(key => {
        url = `${url}&filter[${key}]=${this.filters[key] || ''}`;
      });

      this.loading = true;

      window.Ajax.get(`${url}&sort=created_at&parts=vehicle,abiGroup,pdi`)
        .then(response => {
          this.qcs = response.data.data;
          this.paginator_data = response.data;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },

    setAbiGroup(abiGroup) {
      this.filters.abi_group_id = abiGroup;

      this.getQcs();
    },

    setStatus(status) {
      this.filters.status = status;

      this.getQcs();
    },

    statusLabel(status) {
      const found = this.statuses.find(item => item.key === status);

      return found ? found.value : status;
    },

    statusClass(status) {
      return {
        'badge-success': status === 'completed',
        'badge-warning': status !== 'completed'
      };
    }
  }
};
</script>
